import { BiMessageRoundedMinus } from "react-icons/bi";
import { MdOutlineEmail } from "react-icons/md";
import { IoLocationOutline } from "react-icons/io5";
import BannerImage from "../../assets/contact/ContactUsBg.png";

export const BannerData = {
  image: BannerImage,
  title: "Contact Us",
  desc: "Our dedicated in house charter services are unique in the forwarding industry.",
};
export const GetInTouchData = {
  title: "Don't Hesitate Contact With Us And Solve Your Problem",
  desc: "In the forwarding sector, our devoted in-house charter services are unmatched. We are known for accepting challenges that others deem too tough. The MAC World charter team operates globally around the clock and is always thinking outside the box to match your load with the appropriate aircraft. If your load needs to be moved by air, they will have the solution.",
};

export const ContactData = [
  {
    icon: (
      <BiMessageRoundedMinus
        style={{
          borderRadius: "25px 25px 25px 25px",
          backgroundColor: "#E8E8E8",
          fontSize: "3rem",
          padding: "10px",
        }}
      />
    ),
    title: "Tell with us",
    contact: [+971-4-3219202 , +971-55-2239077],
  },
  {
    icon: (
      <MdOutlineEmail
        style={{
          borderRadius: "25px 25px 25px 25px",
          backgroundColor: "#E8E8E8",
          fontSize: "3rem",
          padding: "10px",
        }}
      />
    ),
    title: "Email Drop Us ",
    contact: "info@macworldlogistics.com",
  },
  {
    icon: (
      <IoLocationOutline
        style={{
          borderRadius: "25px 25px 25px 25px",
          backgroundColor: "#E8E8E8",
          fontSize: "3rem",
          padding: "10px",
        }}
      />
    ),
    title: "Location ",
    contact: "Mac World Logistic LLC, Office No: 105 DNIC Building",
  },
];
